<!-- Added "leaflet-touch" css class to fix bug in bgs-leaflet and apply standard control styling -->
<bgs-leaflet-map id="map_wrapper" #mapComponent [initialLatLng]="[58.5, -10]" [initialZoom]="4" [maxZoom]="24"
  (onload)="leafletMapObjReady()" [class.placing-pin]="placingPin">
</bgs-leaflet-map>